import {
  NavLink,
  Outlet,
} from "react-router-dom";

import ProfessionalPageNav from "../../components/professional/ProfessionalPageNav";

import "../../styles/pages/professional/CredentialManager.css";

const CredentialManager = () => {
  return (
    <main className="credential-manager-page">
      <div className="credential-page-actions">
        <ProfessionalPageNav />
      </div>

      <header className="credential-header">
        <p className="account-label">
          Professional Profile
        </p>

        <h1>Professional Credentials</h1>

        <p className="credential-description">
          Manage your licences, certifications,
          professional documents, and verification
          status.
        </p>
      </header>

      <nav
        className="credential-tabs"
        aria-label="Professional credential sections"
      >
        <NavLink
          to="licenses"
          className={({ isActive }) =>
            isActive ? "active" : ""
          }
        >
          Licences
        </NavLink>

        <NavLink
          to="certifications"
          className={({ isActive }) =>
            isActive ? "active" : ""
          }
        >
          Certifications
        </NavLink>

        <NavLink
          to="documents"
          className={({ isActive }) =>
            isActive ? "active" : ""
          }
        >
          Documents
        </NavLink>

        <NavLink
          to="verification"
          className={({ isActive }) =>
            isActive ? "active" : ""
          }
        >
          Verification
        </NavLink>
      </nav>

      <section className="credential-content">
        <Outlet />
      </section>
    </main>
  );
};

export default CredentialManager;